import { Injectable } from '@angular/core'
import { TracksService } from '../services/tracks.service'
import { PlayerCore as LibPlayerCore } from './common/PlayerCore'
import { PlayerLogic as LibPlayerLogic } from './common/PlayerLogic'
import { PlaylistManager as LibPlaylistManager } from './common/PlaylistManager'
import { TrackResolverAbstract } from './common/TrackResolverAbstract'

@Injectable({ providedIn: 'root' })
export class PlayerCore extends LibPlayerCore {
  constructor() {
    super()
  }
}

@Injectable({ providedIn: 'root' })
export class PlaylistManager extends LibPlaylistManager {
  constructor(private trackResolver: TrackResolverAbstract) {
    super(trackResolver)
  }
}

@Injectable({ providedIn: 'root' })
export class PlayerLogic extends LibPlayerLogic {
  constructor(playerCore: PlayerCore, playlistManager: PlaylistManager, tracksService: TracksService) {
    super(playerCore, playlistManager, tracksService)
  }
}
